"use strict";

import { Inject, Pipe, PipeTransform } from "@angular/core";
import { DatePipe } from "@angular/common";
import { ANGULARJS_TRANSLATE } from "@nms-ng2/app/shared/services/upgraded-provider/upgraded-providers";

/**
 * Pipe responsável por formatar datas.
 *
 * Primeiro, obtém o mês abreviado (três caracteres) traduzido,
 * em seguida, aplica a máscara de data do país e substitui o mês
 * abreviado conforme o idioma configurado.
 */
@Pipe({
    name: "dateFormat"
})
export class DateFormatPipe implements PipeTransform {

    constructor(private readonly datePipe: DatePipe,
                @Inject(ANGULARJS_TRANSLATE) private readonly translate: any) {
    }

    transform(date: Date | string | number): string {
        const month = this.translate.instant("month." + this.datePipe.transform(date, "MM"));
        const fullDate = this.datePipe.transform(date, this.translate.instant("date.format"));
        return fullDate.replace(/[A-z]{3}/g, month);
    }
}
